module.exports = __webpack_public_path__ + "static/media/thumbnail.0dc23c5e.png";